<template>
  <div>

    <Head :title="form.title" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/import-profiles">Profiles</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.title }}
    </h1>
    <div class="max-w-6xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="Title" />

          <select-input v-model="form.connector_id" :error="form.errors.connector_id"
            class="pb-8 pr-6 opacity-80 w-full lg:w-1/2" label="Connector" disabled>
            <option :value="null" />
            <option v-for="connector in connectors" :key="connector.id" :value="connector.id">{{ connector.title }}
            </option>
          </select-input>

          <select-input v-model="form.profile_type" :error="form.errors.profile_type"
            class="pb-8 pr-6 w-full opacity-80 lg:w-1/2" label="Profile Type" disabled>
            <option :value="null" />
            <option value="create">Create</option>
            <option value="update">Update</option>
            <option value="delete">Delete</option>
            <option value="create-update">Create and Update</option>
          </select-input>

          <text-input v-model="form.scheduled_task" :error="form.errors.scheduled_task" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Schedule" />

          <div v-if="connectorFields != null && form.profile_type != 'delete'" class="pb-8 pr-6 w-full">
            <lable class="form-label">Fields :</lable>
            <ul class="flex flex-wrap form-input w-full">
              <li class="mt-1 mb-1 lg:w-1/2 pl-8" v-for="(connectorField, connectorFieldIndex) in connectorFields"
                :key="connectorFieldIndex"><input type="checkbox" :value="connectorFieldIndex"
                  v-bind:id="connectorFieldIndex" v-model="form.fields" /> {{ connectorField }}</li>
            </ul>
          </div>

          <div v-if="connectorFields != null && form.profile_type == 'delete'" class="pb-8 pr-6 w-full">
            <lable class="form-label">Fields :</lable>
            <ul class="flex flex-wrap form-input w-full">
              <li class="mt-1 mb-1 lg:w-1/2 pl-8"><input type="checkbox" value="products" v-model="form.fields" />
                Products</li>
              <li class="mt-1 mb-1 lg:w-1/2 pl-8"><input type="checkbox" value="categories" v-model="form.fields" />
                Categories</li>
            </ul>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2" v-if="modifiersByConnector.length">
            <lable class="form-label">Modifiers :</lable>
            <!-- <ul class="w-full form-input">
              <li class="mt-1 mb-1 pl-8" v-for="modifier in modifiersByConnector" :key="modifier.id"><input type="checkbox" :value="modifier.id" v-bind:id="modifier.id" v-model="form.modifier" /> {{ modifier.title }}</li>
            </ul> -->
            <select class="w-full form-input" v-model="form.modifier" multiple="multiple">
              <option v-for="modifier in modifiersByConnector" :key="modifier.id" :value="modifier.id"> {{ modifier.title }}
              </option>
            </select>
          </div>

          <div v-if="!modifiersByConnector.length" class="pb-8 pr-6 w-full lg:w-1/2">
            <lable class="form-label">Modifiers :</lable>
            <span class="form-input"> Modifier not found. </span>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2" v-if="filtersByConnector.length">
            <lable class="form-label">Filters :</lable>
            <!-- <ul class="w-full form-input">
              <li class="mt-1 mb-1 pl-8" v-for="filter in filtersByConnector" :key="filter.id"><input type="checkbox" :value="filter.id" v-bind:id="filter.id" v-model="form.filters" /> {{ filter.title }}</li>
            </ul> -->
            <select class="w-full form-input" v-model="form.filters" multiple="multiple">
              <option v-for="filter in filtersByConnector" :key="filter.id" :value="filter.id">{{ filter.title }}</option>
            </select>
          </div>



          <div v-if="!filtersByConnector.length" class="pb-8 pr-6 w-full lg:w-1/2">
            <lable class="form-label">Filters :</lable>
            <span class="form-input"> Filter not found. </span>
          </div>

          <div v-if="defaultFields != null && form.profile_type != 'delete'" class="pb-8 pr-6 w-full">
            <div class="flex w-full flex-wrap">
              <label class="w-1/2 form-label">Default Field:</label>
              <label class="w-1/2 form-label">Value:</label>
              <div v-for="(input, index) in mapping_fields" :key="`jsonInput-${index}`"
                class="input pb-5 pr-6 wrapper w-full -center flex items-center mb-3">
                <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                  <select v-model="input.defaultField" class="form-select">
                    <option></option>
                    <option v-for="defaultField in defaultFields" :key="defaultField" :value="defaultField">{{
                      defaultField }}</option>
                  </select>
                </div>
                <div class="h-10 w-1/2 rounded-lg outline-none mr-2">
                  <text-input v-model="input.defaultFieldValue" />
                </div>
                <icon name="plus" @click="addField(input, mapping_fields)" />
                <icon name="remove" v-show="mapping_fields.length > 1" @click="removeField(index, mapping_fields)" />
              </div>
              <div v-if="jsError" class="w-full mb-3 text-center form-error">{{ jsError }}</div>
            </div>
          </div>

          <div v-if="destinationType === 'shopify'" class="w-full flex">
            <div class="pb-8 pr-6w-full lg:w-1/2 flex">
              <lable class="form-label">Publish products to your app</lable>
              <input class="ml-2 w-4 h-4" type="checkbox" value=true v-model="form.publish_to_your_app" />
            </div>
            <div class="pb-8 pr-6 w-full lg:w-1/2 flex">
              <lable class="form-label">Continue selling when out of stock</lable>
              <input class="ml-2 w-4 h-4" type="checkbox" value=true v-model="form.continue_selling" />
            </div>
            <div class="pb-8 pr-6 w-full lg:w-1/2 flex">
              <lable class="form-label">Assign products to all locations</lable>
              <input class="ml-2 w-4 h-4" type="checkbox" value=true v-model="form.assign_all_locations" />
            </div>
          </div>
          <div v-if="destinationType === 'magento'" class="w-full flex">
            <div class="pb-8 pr-6w-full lg:w-1/2 flex">
              <lable class="form-label">Import Category with Parent/Child Relation</lable>
              <input class="ml-2" type="checkbox" value=true v-model="form.import_category_with_relation" />
            </div>
            <div class="pb-8 pr-6w-full lg:w-1/2 flex">
              <lable class="form-label">Import/Update Product Images</lable> 
              <input class="ml-2" type="checkbox" value=true v-model="form.import_product_images" />
            </div>
            <div class="pb-8 pr-6w-full lg:w-1/2 flex">
              <lable class="form-label">Import/Update Product Images (Create Only)</lable> 
              <input class="ml-2" type="checkbox" value=true v-model="form.import_product_images_only_create" />
            </div>
          </div>
          <div v-if="shop === 'elsalg'" class="w-full flex">
            <div class="pb-8 pr-6w-full lg:w-1/3 flex">
              <lable class="form-label">Import Symbols</lable>
              <input class="ml-2" type="checkbox" value=true v-model="form.import_symbols" />
            </div>
            <div class="pb-8 pr-6w-full lg:w-1/3 flex">
              <lable class="form-label">Import Locations</lable>
              <input class="ml-2" type="checkbox" value=true v-model="form.import_locations" />
            </div>
            <div class="pb-8 pr-6w-full lg:w-1/3 flex">
              <lable class="form-label">Import Product Options</lable>
              <input class="ml-2" type="checkbox" value=true v-model="form.import_options" />
            </div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete
            Profile</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update
            Profile</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
    SelectInput,
  },
  layout: Layout,
  props: {
    importProfile: Object,
    connectors: Array,
    filters: Array,
    modifiers: Array,
    default_fields: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: this.importProfile.title,
        connector_id: this.importProfile.connector_id,
        fields: this.importProfile.fields.split(','),
        scheduled_task: this.importProfile.scheduled_task,
        modifier: this.importProfile.modifier,
        filters: this.importProfile.filters,
        profile_type: this.importProfile.profile_type,
        publish_to_your_app: this.importProfile.publish_to_your_app == 1 ? true : false,
        continue_selling: this.importProfile.continue_selling == 1 ? true : false,
        assign_all_locations: this.importProfile.assign_all_locations == 1 ? true : false,
        import_category_with_relation: this.importProfile.import_category_with_relation == 1 ? true : false,
        import_product_images: this.importProfile.import_product_images == 1 ? true : false,
        import_product_images_only_create: this.importProfile.import_product_images_only_create == 1 ? true : false,
        import_symbols: this.importProfile.import_symbols == 1 ? true : false,
        import_locations: this.importProfile.import_locations == 1 ? true : false,
        import_options: this.importProfile.import_options == 1 ? true : false,
        default_fields: JSON.stringify(JSON.parse(this.importProfile.default_fields), null, 2),
      }),
      shop: null,
      destinationType: null,
      connectorFields: null,
      modifiersByConnector: [],
      filtersByConnector: [],

      defaultFields: null,
      mapping_fields: [],
      jsError: null,
    }
  },
  async mounted() {
    await this.connectors.forEach((value, index) => {
      if (value.id == this.form.connector_id) {
        let json = value.mapping_json
        this.connectorFields = JSON.parse(json)

        this.modifiers.forEach((value, index) => {
          if (value.connector_id == this.form.connector_id) {
            this.modifiersByConnector.push(value)
          }
        })

        this.filters.forEach((value, index) => {
          if (value.connector_id == this.form.connector_id) {
            this.filtersByConnector.push(value)
          }
        })
        this.shop = value.shop
        if (value.destination == 'shopify') {
          this.destinationType = 'shopify';
          this.defaultFields = this.default_fields.shopify
        } else if (value.destination == 'magento') {
          this.destinationType = 'magento';
          this.defaultFields = this.default_fields.magento
        } else {
          this.defaultFields = []
        }
        let obj = JSON.parse(this.importProfile.default_fields)
        for (let i = 0; i < Object.keys(obj).length; i++) {
          let defaultField = Object.keys(obj)[i]
          let defaultFieldValue = obj[defaultField]
          let newObj = {
            defaultField: defaultField,
            defaultFieldValue: defaultFieldValue,
          }
          this.mapping_fields.push(newObj)
        }
        if (this.mapping_fields.length == 0) {
          this.mapping_fields = [{ defaultField: '', defaultFieldValue: '' }]
        }
      }
    })

    if (this.form.modifier) {
      console.log('test')
      this.form.modifier = this.importProfile.modifier.split(',')
    }

    if (this.form.filters) {
      console.log('test 1')
      this.form.filters = this.importProfile.filters.split(',')
    }

  },
  methods: {
    update() {
      let fieldJson = {}
      this.mapping_fields.forEach((element) => {
        if (element.defaultField && element.defaultFieldValue) {
          let data = {
            [element.defaultField]: element.defaultFieldValue,
          }
          Object.assign(fieldJson, data)
        }
      })
      this.form.default_fields = JSON.stringify(fieldJson, null, 2)
      this.form.put(`/import-profiles/${this.importProfile.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this filter?')) {
        this.$inertia.delete(`/import-profiles/${this.importProfile.id}`)
      }
    },
    addField(value, fieldType) {
      this.jsError = null
      console.log(value)
      console.log(fieldType)
      if (value.defaultField == '' || value.defaultFieldValue == '') {
        this.jsError = 'please select Field.'
      } else {
        fieldType.push({ defaultField: '', defaultFieldValue: '' })
      }
    },
    removeField(index, fieldType) {
      fieldType.splice(index, 1)
      this.mapping_fields = fieldType
    },
  },
}
</script>
